const GoogleMaps = (function () {
    'use strict';

    const app = {
        activeMarkers: [],
        bounds: undefined,
        map: undefined,

        init: function (zoom) {
            if (typeof zoom === 'undefined') {
                zoom = 6;
            }

            initGoogleMaps().then(maps => {
                app.bounds = new maps.LatLngBounds();
                app.map = new maps.Map(document.getElementById('g-maps-container'), {
                    center: {lat: 61.4797525, lng: 8.7226841},
                    zoom: zoom,
                    scrollwheel: false,
                });
            }).catch(e => {});


            return app;
        },

        placeSingleMark: function (company, shouldRefreshBounds) {

            return new Promise((resolve, reject) => {

                if (!company.location) reject();

                if (shouldRefreshBounds === undefined) shouldRefreshBounds = true;

                let lat = parseFloat(company.location.lat),
                    lng = parseFloat(company.location.lon);

                if (!lat || !lng) reject();

                initGoogleMaps().then(() => {


                    let marker = new google.maps.Marker({
                        map: app.map,
                        position: {
                            lat: lat,
                            lng: lng
                        },
                        title: company.name
                    });

                    let infoWindow = new google.maps.InfoWindow({
                        content: `<p style="margin:0;">
                                <b><a href="/bedrift/${company.id}/${slugify(company.name)}">${company.name}</a></b>
                                <br />${company.address}</p>`
                    });

                    marker.addListener('click', function () {
                        infoWindow.open(app.map, marker);
                    });

                    app.activeMarkers.push(marker);
                    app.bounds.extend(marker.position);

                    if (shouldRefreshBounds) {
                        app.map.fitBounds(app.bounds);

                        let a = google.maps.event.addListenerOnce(app.map, 'bounds_changed', function (e) {
                            if (this.getZoom()) {
                                this.setZoom(16);
                            }

                            resolve();
                        });

                        setTimeout(function () {
                            google.maps.event.removeListener(a);
                        }, 3000);
                    }
                    else {
                        resolve();
                    }

                }).catch(() => {});
            });
        },

        placeMarks: function (companies) {
            companies.forEach(function (company) {
                app.placeSingleMark(company, false);
            });
            if (companies.length > 1 && app.map) {
                app.map.fitBounds(app.bounds);
            } else if (app.map) {
                let pt = new google.maps.LatLng(parseFloat(companies[0].location.lat), parseFloat(companies[0].location.lon));
                app.map.setCenter(pt);
                app.map.setZoom(15);
            }
        },

        clearMarkers: function () {
            app.activeMarkers.forEach(function (marker) {
                marker.setMap(null);
            });

            app.activeMarkers = [];
        }
    };

    return {
        init: app.init,
        placeMarks: app.placeMarks,
        clearMarkers: app.clearMarkers,
        placeSingleMark: app.placeSingleMark,
        zoom: x => {
            app.map.setZoom(x);
        }
    };
}());
